import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { useSelector } from "react-redux";
import { checkAccessFn } from "../../../../utils/checkAccess";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { Link } from "react-router-dom";
import Highlighter from "react-highlight-words";

export default function ListDataClient({
  list = [],
  editData,
  deleteData,
  loading,
  titles = [],
  addData,
}) {
  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) => {
    return checkAccessFn(dashboardData, module, name);
  };
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list?.data || []);

  const [searchWords, setSearchWords] = useState([]);
  return (
    <div className="pt-2 uppercase">
      <div className="flex flex-wrap  gap-2 w-full items-center ">
        {checkAccess("Client", "client-create") && (
          <Link to="/dashboard/client/create">
            <button
              className="p-2 bg-red text-white rounded-md"
              onClick={addData}
            >
              ADD NEW CLIENT +
            </button>
          </Link>
        )}
        <Search
          searchKey={[
            "client_id",
            "sponsor_id",
            "authorized_person_name",
            "company_registration",
          ]}
          setSearchWords={setSearchWords}
        />
      </div>
      <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
      <CountPerPage />
      <div
        className={`grid grid-cols-table-client auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
      >
        {titles.map((t, index) => (
          <p key={index} className="font-semibold uppercase">
            {t}
          </p>
        ))}
        {list?.isLoading && <LoadingWithLable className="col-span-7" />}
        {!list?.isLoading && <NoDataFound />}

        {!list?.isLoading
          ? currentList?.map((list, index) => (
              <React.Fragment key={index}>
                <PaginationIndex index={index} />
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.client_id || ""}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.name || ""}
                  />
                </p>
                <p className="overflow-x-hidden">
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.sponsor_id || ""}
                  />
                </p>

                <p>
                  {" "}
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.authorized_person_name || ""}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.company_registration || ""}
                  />
                </p>

                <div className="flex gap-3 min-w-fit ">
                  {checkAccess("Client", "client-edit") ? (
                    <button
                      className={
                        list?.isLoading || currentList.length <= 0
                          ? "p-1 px-2 rounded-md ring-1 ring-slate-600 opacity-50"
                          : "p-1 px-2 rounded-md ring-1 ring-slate-600"
                      }
                      onClick={() => editData(list.id)}
                      disabled={
                        loading.edit ||
                        list?.isLoading ||
                        currentList.length <= 0
                      }
                    >
                      {loading.edit && loading.loadingId === list.id ? (
                        <CgSpinner className="animate-spin mx-auto" />
                      ) : (
                        <CiEdit size={"1.4rem"} />
                      )}
                    </button>
                  ) : (
                    <button className="p-1 px-2 rounded-md ring-1 ring-slate-200">
                      --
                    </button>
                  )}

                  {checkAccess("Client", "client-delete") ? (
                    <button
                      className={
                        list?.isLoading || currentList.length <= 0
                          ? "p-1 px-2 rounded-md ring-1 ring-red text-white bg-red opacity-50"
                          : "p-1 px-2 rounded-md ring-1 ring-red text-white bg-red"
                      }
                      onClick={() =>
                        deleteData((oldState) => ({ open: true, id: list.id }))
                      }
                      disabled={
                        loading.delete ||
                        list?.isLoading ||
                        currentList.length <= 0
                      }
                    >
                      {loading.delete && loading.loadingId === list.id ? (
                        <CgSpinner className="animate-spin mx-auto" />
                      ) : (
                        <MdDeleteOutline size={"1.4rem"} />
                      )}
                    </button>
                  ) : (
                    <button className="p-1 px-2 rounded-md ring-1 ring-slate-200">
                      --
                    </button>
                  )}
                </div>
                <hr
                  className={`border-[1.5px] border-slate-100  w-full col-span-7 `}
                />
              </React.Fragment>
            ))
          : ""}
      </div>
      <Pagination />
    </div>
  );
}
